var DealEventPipe;

if (window.Discount == null) {
  window.Discount = {};
}

DealEventPipe = require('../../../deal/frontend/event_pipe');

Discount.View = Backbone.View.extend({
  el: "#discount-data, .discount-data",
  initialize: function() {
    return DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateTiles(priceData);
      };
    })(this));
  },
  updateTiles: function(arg) {
    var hideOriginalPriceAndDiscount, percent, savings, value;
    value = arg.value, percent = arg.percent, savings = arg.savings, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    this.$("#discount-value, .discount-value").html(value);
    this.$("#discount-percent, .discount-percent").html(percent);
    this.$("#discount-you-save, .discount-you-save").html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents(".deal-discount").hide();
    } else {
      return this.$el.parents(".deal-discount").show();
    }
  }
});

module.exports = Discount;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kaXNjb3VudC9mcm9udGVuZC92aWV3cy9kaXNjb3VudC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9tb2R1bGVzL2Rpc2NvdW50L2Zyb250ZW5kL3ZpZXdzL2Rpc2NvdW50LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOzs7RUFBQSxNQUFNLENBQUMsV0FBWTs7O0FBRW5CLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLG1DQUFSOztBQUVoQixRQUFRLENBQUMsSUFBVCxHQUFnQixRQUFRLENBQUMsSUFBSSxDQUFDLE1BQWQsQ0FDZDtFQUFBLEVBQUEsRUFBSSxnQ0FBSjtFQUVBLFVBQUEsRUFBWSxTQUFBO1dBQ1YsYUFBYSxDQUFDLEVBQWQsQ0FBaUIsYUFBakIsRUFBZ0MsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLFNBQUQ7ZUFBZSxLQUFDLENBQUEsV0FBRCxDQUFhLFNBQWI7TUFBZjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBaEM7RUFEVSxDQUZaO0VBS0EsV0FBQSxFQUFhLFNBQUMsR0FBRDtBQUNYLFFBQUE7SUFEYSxtQkFBTyx1QkFBUyx1QkFBUztJQUN0QyxJQUFDLENBQUEsQ0FBRCxDQUFHLGtDQUFILENBQXNDLENBQUMsSUFBdkMsQ0FBNEMsS0FBNUM7SUFDQSxJQUFDLENBQUEsQ0FBRCxDQUFHLHNDQUFILENBQTBDLENBQUMsSUFBM0MsQ0FBZ0QsT0FBaEQ7SUFDQSxJQUFDLENBQUEsQ0FBRCxDQUFHLHdDQUFILENBQTRDLENBQUMsSUFBN0MsQ0FBa0QsT0FBbEQ7SUFDQSxJQUFHLDRCQUFIO2FBQ0UsSUFBQyxDQUFBLEdBQUcsQ0FBQyxPQUFMLENBQWEsZ0JBQWIsQ0FBOEIsQ0FBQyxJQUEvQixDQUFBLEVBREY7S0FBQSxNQUFBO2FBR0UsSUFBQyxDQUFBLEdBQUcsQ0FBQyxPQUFMLENBQWEsZ0JBQWIsQ0FBOEIsQ0FBQyxJQUEvQixDQUFBLEVBSEY7O0VBSlcsQ0FMYjtDQURjOztBQWdCaEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
